
import uiRouterModule from "@uirouter/angularjs";

//import Assert from "tbAssert";
import DependencyListBuilder from "./utility/DependencyListBuilder";
import TbAuthServiceModule from "tbClient/services/auth";

//import Application Insights handler module
import appInsightsModule from "./services/AppInsights";

//import TrackerBase app configuration data service module
import TbAppConfigDataServiceModule from "./config/tb-app-config/TbAppConfigDataService";

function TrackerbaseAppConfiguration(
    $locationProvider,
    appInsightsProvider,
    $urlServiceProvider,
    $uiRouterProvider,
    $logProvider,
    TbAppConfigDataServiceProvider,
    TbAuthServiceProvider
)
{
    TbAppConfigDataServiceProvider.init(window.TbAppConfigData);
    const tbAppConfigData = TbAppConfigDataServiceProvider.appConfig;

    $locationProvider.html5Mode(true).hashPrefix("!");
    $logProvider.debugEnabled(tbAppConfigData.tbEnableDebugMode);
    //$uiRouterProvider.trace.enable("TRANSITION", "HOOK", "UIVIEW");
    $uiRouterProvider.trace.disable();
    $urlServiceProvider.config.strictMode(false);
    $urlServiceProvider.rules.otherwise("/tracking-calendar/");

    TbAuthServiceProvider.configureAuth(tbAppConfigData);
    appInsightsProvider.InitializeSDK(tbAppConfigData.tbAppInsightsApiKey);
}

TrackerbaseAppConfiguration.$inject = [
    "$locationProvider",
    "appInsightsProvider",
    "$urlServiceProvider",
    "$uiRouterProvider",
    "$logProvider",
    "TbAppConfigDataServiceProvider",
    "TbAuthServiceProvider"
];

TrackerbaseAppConfiguration.dependencies = DependencyListBuilder([
    //handleUnMatchedUrls.dependencies,
    [
        uiRouterModule,
        appInsightsModule,
        TbAppConfigDataServiceModule,
        TbAuthServiceModule
    ]
]);

export default TrackerbaseAppConfiguration;



//////////////////
// WEBPACK FOOTER
// ./src/TrackerbaseAppConfiguration.js
// module id = 3jm9
// module chunks = 1